export default function reportTypeDirective() {
  return {
    template: require('./report-type.html'),
    controller: 'GRReportTypeController',
    controllerAs: 'grReportTypeVM',
    bindToController: true,
    replace: true,
    scope: {
      customerId: '@',
      reportType: '=',
    },
  };
}
